import React from "react";
import useRestaurantTimeZone from "../util/hooks/useRestaurantTimeZone";
import {
	DEFAULT_DISPLAY_DATE_FORMAT,
	DISPLAY_EMPTY,
	formatDualTimezoneTooltip,
	formatYourTimeTooltip,
	getTimestampParts,
	isUsableTimeZone,
} from "../util/date.util";
import Tooltip from "./Tooltip";

const Timestamp = ({ value, format = DEFAULT_DISPLAY_DATE_FORMAT, variant = "inline", placement = "auto" }) => {
	const restaurantTimeZone = useRestaurantTimeZone();

	if (!isUsableTimeZone(restaurantTimeZone)) {
		return DISPLAY_EMPTY;
	}

	const { restaurant, local } = getTimestampParts(value, {
		timeZone: restaurantTimeZone,
		formatString: format,
	});

	if (!restaurant || restaurant === DISPLAY_EMPTY) {
		return DISPLAY_EMPTY;
	}

	if (variant === "tooltipOnly") {
		return <Tooltip text={formatDualTimezoneTooltip(restaurant, local)} placement={placement} />;
	}

	return (
		<div style={{ display: "inline-flex", alignItems: "center", gap: "0.25rem" }}>
			{restaurant}
			<Tooltip text={formatYourTimeTooltip(local)} placement={placement} />
		</div>
	);
};

export default Timestamp;
